import React, { use } from 'react'
import { Stack } from '@tumelo/designsystem'
import Link from 'next/link'
import styled from 'styled-components'
import { UserContext } from '@/application/Providers/AuthProvider'
import { AvatarWithInitials } from './AvatarWithInitials'

export const HeaderProfileIcon: React.FC = () => {
  const { user } = use(UserContext)

  return (
    <StyledContainer>
      <Stack flexDirection="row" gap="0.8rem">
        <Link href="/profile">
          <AvatarWithInitials firstName={user.givenName} lastName={user.familyName} />
        </Link>
      </Stack>
    </StyledContainer>
  )
}

const StyledContainer = styled.div`
  position: relative;
`
